(function ($, Cobalt, undefined) {
    var _insertCallback;
    Cobalt.VideoEmbed = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.UI, name: "Cobalt.UI"}];
        },

        initialize: function () {
            Cobalt.runOnHtmlInsert(function ($parent) {
                var videoEmbedAnchor = $parent.find('a[data-video-embed]');
                var otherEmbedAnchors = $('a[data-video-embed]').not(videoEmbedAnchor);
                var count = otherEmbedAnchors.length;
                if (videoEmbedAnchor.length > 0) {
                    videoEmbedAnchor.each(function () {
                        count = Cobalt.VideoEmbed.bindEmbed($(this), count);
                    });
                }
            });
        },
        bindEmbed: function (anchor, count) {
            var playIcon = Cobalt.Constants.StaticURL + '/Skins/Global/images/ui/video-embed-play.png';
            var closeIcon = Cobalt.Constants.StaticURL + '/Skins/Global/images/ui/video-embed-close.png';
            var imageID = "video-embed-inline-play-" + count;
            var embedID = "video-embed-code-" + count;
            var embedParent = $("<span>").addClass("u-videoEmbed");
            anchor.before(embedParent);
            embedParent.append(anchor);

            embedParent.prepend($("<span>").attr("id", imageID).addClass("play-video").addClass("tip").attr("title", "Click to watch video"));
            embedParent.append($("<span>").attr("id", embedID).addClass("video-container").hide());

            $("#" + imageID).live("click", function () {
                var embed = $("#" + embedID);
                embedParent.addClass("s-expanded");
                if (embed.is(":hidden")) {
                    if (embed.html().length === 0) {
                        embed.append(anchor.attr("data-video-embed"));
                    }
                    embed.show();
                    $(this).attr("src", closeIcon);
                } else {
                    embed.hide();
                    embed.empty();
                    embedParent.removeClass("s-expanded");
                    $(this).attr("src", playIcon);
                }
            });

            return count + 1;
        },
        showForm: function (urlSrc, width, height) {

            $.get('/video-embed-platform/get-form', function (data) {
                var $form = $(data);

                var widthField = $form.find("#form-field-manual-width");
                var heightField = $form.find("#form-field-manual-height");
                var manualSetWidthAndHeightField = $form.find("#field-manual-width-and-height");
                var manualsSet = manualSetWidthAndHeightField.attr("data-manual-width") != width || manualSetWidthAndHeightField.attr("data-manual-height") != height;
                var supportsManualWidthAndHeight = manualSetWidthAndHeightField.length > 0;

                if (supportsManualWidthAndHeight) {
                    if (width !== undefined && width !== 0) {
                        $form.find("#field-manual-width").val(width);
                        if (manualsSet) {
                            manualSetWidthAndHeightField.attr("checked", "checked");
                        } else {
                            widthField.hide();
                        }
                    }

                    if (height !== undefined && height !== 0) {
                        $form.find("#field-manual-height").val(height);
                        if (manualsSet) {
                            manualSetWidthAndHeightField.attr("checked", "checked");
                        } else {
                            heightField.hide();
                        }
                    }

                    manualSetWidthAndHeightField.click(function () {
                        var checkbox = $(this);
                        if (checkbox.is(":checked")) {
                            widthField.show();
                            heightField.show();
                        }
                        else {
                            widthField.hide();
                            heightField.hide();
                        }
                    });
                }

                var $dlg = $("<div/>");

                $dlg.append($form);

                if (urlSrc != "") {
                    $dlg.find("#video-embed-form form #field-embed-url").val(urlSrc);
                }

                $dlg.find("#video-embed-form form").submit(function (e) {
                    e.preventDefault();
                    var urlField = $('#field-embed-url').val();
                    var urlData = null
                    if (supportsManualWidthAndHeight) {
                        var widthFieldVal = $("#field-manual-width").val();
                        var heightFieldVal = $("#field-manual-height").val();
                        urlData = { url: urlField, width: widthFieldVal, height: heightFieldVal };
                    }
                    else {
                        urlData = { url: urlField };
                    }

                    $.get('/video-embed-platform/get-embed-code.json', urlData, function (data) {

                        if (data.hasError) {
                            alert(data.errorDescription);
                            return false;
                        }
                        else {
                            $dlg.dialog("destroy");
                            $dlg.remove();

                            _insertCallback(data.embedCode);
                            return false;
                        }
                    });
                });

                $dlg.dialog({
                    modal: true,
                    width: 500,
                    dialogClass: "modal",
                    draggable: false,
                    title: "Video URL",
                    resizable: false,
                    close: function (event, ui) {
                        $(event.target).dialog("destroy");
                        $(event.target).remove();
                    }
                });
            });
        },
        showModal: function (urlSrc, width, height, insertCallback) {

            _insertCallback = insertCallback;
            try {
                Cobalt.VideoEmbed.showForm(urlSrc, width, height);
            } catch (e) { }
        }

    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.VideoEmbed.js